import { fastApi } from "@/redux/api/fastApi";

export const brandCartApi = fastApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrandSummary: builder.query({
      query: ({ brand }) => ({
        url: `/brand_cart/summary?brand=${brand}`,
        method: "GET",
      }),
      providesTags: ["BrandCart"],
    }),

    getAllBrandCart: builder.query({
      query: ({ brand }) => ({
        url: `/brand_cart?brand=${brand}`,
        method: "GET",
      }),
    }),

    getCartBrandVideos: builder.query({
      query: ({ brand, page = 1, limit = 10 }) => ({
        url: `/brand_cart/brand_videos?brand=${brand}&page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),

    getCartCompetitorNames: builder.query({
      query: ({ brand }) => ({
        url: `/brand_cart/competitor_names?brand=${brand}`,
        method: "GET",
      }),
    }),

    getCartCompetitorVideos: builder.query({
      query: ({ brand, page = 1, limit = 10 }) => ({
        url: `/brand_cart/competitor_videos?brand=${brand}&page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),

    getCartVideosByCompetitor: builder.query({
      query: ({ competitorName, brand }) => ({
        url: `/brand_cart/videos_by_competitor?competitor_name=${competitorName}&brand=${brand}`,
        method: "GET",
      }),
    }),

    //add manual competitor
    addCartCompetitor: builder.mutation({
      query: (payload) => ({
        url: `/brand_cart/manual_competitor/add`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetBrandSummaryQuery,
  useGetAllBrandCartQuery,
  useGetCartBrandVideosQuery,
  useGetCartCompetitorNamesQuery,
  useGetCartCompetitorVideosQuery,
  useGetCartVideosByCompetitorQuery,
  useAddCartCompetitorMutation,
} = brandCartApi;
